import React, { createContext, useContext, useEffect, useState } from "react";

export const IMG = {
  portrait: "/doctor-portrait.jpg",
  homeopathy:
    "https://images.pexels.com/photos/6693968/pexels-photo-6693968.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  clinic:
    "https://images.unsplash.com/photo-1677735476292-0fc57ab097b2?crop=entropy&cs=srgb&fm=jpg&q=85",
  nutrition: "/medicina-naturale.jpg",
  studio:
    "https://images.unsplash.com/photo-1615194787278-25ca9b7c5a16?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const CONTACT = {
  phone: "+39 349 234 4166",
  email: "info@studioangile.it",
  address: "Via Forno 26/F",
  city: "35030 Selvazzano Dentro (PD)",
  fullAddress: "Via Forno 26/F, 35030 Selvazzano Dentro (PD)",
  lat: 45.393313,
  lon: 11.816483,
  hours_it: "Si riceve su appuntamento",
  hours_en: "By appointment only",
};

const it = {
  nav: {
    home: "Home",
    trattamenti: "Trattamenti",
    articoli: "Articoli",
    curriculum: "Curriculum",
    contatti: "Contatti",
    sezioni: "Sezioni",
    prenota: "Prenota una visita",
    menu: "Menu",
    chiudi: "Chiudi",
  },
  hero: {
    eyebrow: "Studio medico · Medicina naturale",
    line1: "Medicina che",
    line2: "ascolta",
    line2accent: "la persona.",
    sub: "Il Dott. Giovanni Angilè unisce rigore clinico e cultura omeopatica, neuralterapica e naturale, per percorsi di cura costruiti su misura.",
    cta1: "Prenota una visita",
    cta2: "Scopri i trattamenti",
    disciplines: ["Omeopatia", "Neuralterapia", "Medicina naturale", "Fitoterapia", "Ascolto clinico"],
    portraitCaption: "Dott. Giovanni Angilè — Medico chirurgo",
  },
  about: {
    eyebrow: "Il medico",
    title: "Un approccio clinico che mette la storia della persona al centro",
    body1: "Medico chirurgo con anni di esperienza nella medicina integrata, il Dott. Angilè combina la diagnostica convenzionale con le discipline naturali, perché ogni percorso di cura nasca da una comprensione completa del paziente.",
    body2: "La prima visita è dedicata all'ascolto: sintomi, ritmo di vita, storia personale. Solo dopo l'accertamento diagnostico si costruisce insieme il percorso più adatto.",
    quote: "Il tempo dedicato all'ascolto non è tempo perso: è terapia.",
    cta: "Leggi il curriculum",
  },
  treatments: {
    eyebrow: "Trattamenti",
    title: "Le tre discipline dell'ambulatorio",
    sub: "Tre linguaggi diversi della cura, un unico metodo: l'accertamento diagnostico prima di ogni scelta terapeutica.",
    cta: "Approfondisci",
    topArticles: "I 4 articoli più letti",
    reads: "letture",
    allArticles: "Tutti gli articoli della sezione",
    items: [
      {
        name: "Omeopatia",
        tagline: "Il principio del simile",
        description:
          "Visite omeopatiche con rimedi personalizzati, inquadramento completo e follow-up programmati per valutare la reattività del paziente.",
      },
      {
        name: "Neuralterapia",
        tagline: "Riequilibrare il segnale nervoso",
        description:
          "Micro-iniezioni di anestetico locale in punti definiti — cicatrici, aree riflesse, gangli — per riequilibrare il sistema neurovegetativo.",
      },
      {
        name: "Medicina naturale",
        tagline: "Alimentazione e stile di vita",
        description:
          "Un'alimentazione consapevole e naturale può favorire l'equilibrio dell'organismo e accompagnarti verso uno stile di vita più sano.",
      },
    ],
  },
  articles: {
    eyebrow: "Articoli",
    title: "Scritti e riflessioni cliniche",
    sub: "Divulgazione seria: accertamento prima di tutto, anche nel contenuto scientifico.",
    cta: "Leggi tutti gli articoli",
    empty: "Nessun articolo pubblicato.",
    loading: "Caricamento…",
  },
  contacts: {
    eyebrow: "Contatti",
    title: "Prenota una visita",
    sub: "Scrivi per informazioni o per fissare un appuntamento in ambulatorio.",
    form: {
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono (facoltativo)",
      message: "Messaggio",
      submit: "Invia richiesta",
      sending: "Invio…",
      success: "Richiesta inviata. Grazie, verrai ricontattato al più presto.",
      error: "Errore nell'invio. Riprova o chiama direttamente l'ambulatorio.",
      bookingEyebrow: "Prenotazioni",
      disabledBody: "Per informazioni e per prenotare una visita, contatta direttamente l'ambulatorio.",
    },
    booking: {
      eyebrow: "Prenota online",
      title: "Prenota la tua visita",
      sub: "Scegli un giorno disponibile, poi l'orario che preferisci: l'ambulatorio ti confermerà l'appuntamento.",
      pickDay: "1. Scegli il giorno",
      pickTime: "2. Scegli l'orario",
      details: "3. I tuoi dati",
      noSlots: "Nessun orario disponibile per questo giorno.",
      name: "Nome e cognome",
      phone: "Telefono",
      email: "Email (facoltativa)",
      notes: "Note (facoltative)",
      confirm: "Conferma prenotazione",
      submitting: "Invio…",
      success: "Richiesta inviata: l'ambulatorio ti confermerà l'appuntamento.",
      booked: "Ops, questo orario è appena stato prenotato. Scegline un altro.",
      error: "Errore nell'invio. Riprova o chiama l'ambulatorio.",
      pickDayFirst: "Seleziona un giorno per vedere gli orari",
    },
    info: {
      phone: "Telefono",
      address: "Indirizzo",
      hours: "Ricevimento",
    },
    mapNote: "Mappa personalizzata con l'indirizzo dell'ambulatorio.",
    directions: "Indicazioni stradali",
    openMap: "Indicazioni anche su OpenStreetMap",
  },
  curriculum: {
    eyebrow: "Curriculum",
    title: "Formazione, specializzazioni ed esperienza clinica",
    formation: "Formazione",
    experiences: "Esperienza clinica",
    specializations: "Ambiti di specializzazione",
    philosophy: "La filosofia clinica",
    philosophyBody:
      "Curare significa capire: ogni percorso nasce da un'anamnesi completa e da un'accertamento condiviso con il paziente. Le discipline naturali non sostituiscono la medicina convenzionale: la integrano, quando ci sono le condizioni per farlo in sicurezza.",
  },
  footer: {
    tagline: "Studio medico di omeopatia, neuralterapia e medicina naturale.",
    nav: "Navigazione",
    contacts: "Contatti",
    disclaimer:
      "Le informazioni presenti su questo sito hanno scopo puramente informativo e non sostituiscono in alcun modo il parere del medico.",
    rights: "Tutti i diritti riservati.",
  },
  admin: {
    login: "Area riservata",
    loginSub: "Accedi per gestire articoli e messaggi.",
    email: "Email",
    password: "Password",
    signIn: "Accedi",
    logout: "Esci",
    tabArticles: "Articoli",
    tabMessages: "Messaggi",
    newArticle: "Nuovo articolo",
    editArticle: "Modifica articolo",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    title: "Titolo",
    titleEn: "Titolo (inglese)",
    category: "Categoria",
    excerpt: "Occhiello",
    excerptEn: "Occhiello (inglese)",
    content: "Contenuto",
    contentEn: "Contenuto (inglese)",
    cover: "Immagine di copertina (URL)",
    date: "Data di pubblicazione",
    saved: "Articolo salvato.",
    enSection: "Versione inglese (opzionale)",
    enSectionAdd: "Aggiungi versione inglese (opzionale)",
    guideText:
      "I campi con * sono obbligatori: titolo, categoria, occhiello (breve sintesi) e contenuto. Immagine, sezione e versione inglese sono facoltative — la versione inglese resta nascosta finché non serve.",
    deleted: "Articolo eliminato.",
    confirmDelete: "Eliminare definitivamente questo articolo?",
    noMessages: "Nessun messaggio ricevuto.",
    loading: "Caricamento…",
    section: {
      tab: "Sezioni",
      new: "Nuova sezione",
      edit: "Modifica sezione",
      subtitle: "Sottotitolo",
      subtitleEn: "Sottotitolo (inglese)",
      body: "Contenuto",
      bodyEn: "Contenuto (inglese)",
      image: "Immagine (URL)",
      inMenu: "Mostra nel menu di navigazione",
      order: "Ordine di visualizzazione",
      saved: "Sezione salvata.",
      deleted: "Sezione eliminata.",
      confirmDelete: "Eliminare definitivamente questa sezione?",
      empty: "Nessuna sezione creata. Creane una dal pulsante in alto a destra.",
      notFound: "Sezione non trovata.",
    },
  },
  sectionPage: { notFound: "Sezione non trovata." },
  cancel: {
    title: "Disdetta prenotazione",
    summary: "La tua visita",
    time: "Orario",
    name: "Paziente",
    confirm: "Conferma disdetta",
    cancelling: "Annullamento…",
    done: "Prenotazione disdetta",
    cancelled: "La tua prenotazione è stata annullata: l'orario è di nuovo disponibile per altri pazienti.",
    keep: "No, mantieni la prenotazione",
    backHome: "Torna al sito",
    invalid: "Link di disdetta non valido o prenotazione già annullata.",
    error: "Errore. Riprova o chiama l'ambulatorio.",
  },
  seo: {
    home: {
      title: "Omeopatia, Neuralterapia e Medicina Naturale — Dott. Angilè",
      desc: "Studio medico del Dott. Giovanni Angilè a Selvazzano Dentro (PD): omeopatia, neuralterapia e medicina naturale. Percorsi su misura, si riceve su appuntamento.",
    },
    trattamenti: {
      title: "Trattamenti — Omeopatia, Neuralterapia, Medicina Naturale",
      desc: "Le tre discipline dell'ambulatorio del Dott. Angilè: visite omeopatiche personalizzate, neuralterapia del dolore, alimentazione consapevole e medicina naturale.",
    },
    articoli: {
      title: "Articoli di omeopatia e medicina naturale — Dott. Angilè",
      desc: "Articoli e riflessioni cliniche del Dott. Angilè su omeopatia, neuralterapia e medicina naturale, con un principio: l'accertamento diagnostico prima di tutto.",
    },
    curriculum: {
      title: "Curriculum ed esperienza clinica — Dott. Giovanni Angilè",
      desc: "Formazione, specializzazioni ed esperienza clinica del Dott. Giovanni Angilè: omeopatia classica, neuralterapia, fitoterapia e medicina dello stile di vita.",
    },
    contatti: {
      title: "Contatti e prenotazioni — Studio Dott. Angilè (PD)",
      desc: "Prenota una visita o contatta l'ambulatorio del Dott. Angilè a Selvazzano Dentro (PD): telefono +39 349 234 4166, si riceve su appuntamento.",
    },
    sezioni: {
      title: "Sezioni tematiche — Dott. Angilè",
      desc: "Le sezioni di articoli del sito del Dott. Angilè: omeopatia, neuralterapia, medicina naturale e metodo clinico. Approfondimenti con rigore clinico.",
    },
  },
  marquee: ["Omeopatia", "Neuralterapia", "Medicina naturale", "Fitoterapia", "Ascolto clinico"],
  sezioniPage: {
    eyebrow: "Esplora",
    title: "Le sezioni",
    sub: "Ogni sezione raccoglie gli articoli dedicati a un tema: scegli il tuo percorso di lettura.",
    empty: "Nessuna sezione pubblicata.",
    articles: "articoli",
    article: "articolo",
  },
};

const en = {
  nav: {
    home: "Home",
    trattamenti: "Treatments",
    articoli: "Articles",
    curriculum: "Curriculum",
    contatti: "Contacts",
    sezioni: "Sections",
    prenota: "Book a visit",
    menu: "Menu",
    chiudi: "Close",
  },
  hero: {
    eyebrow: "Medical practice · Natural medicine",
    line1: "Medicine that",
    line2: "listens",
    line2accent: "to the person.",
    sub: "Dr. Giovanni Angilè combines clinical rigour with homeopathy, neuraltherapy and natural medicine, building care pathways tailored to each patient.",
    cta1: "Book a visit",
    cta2: "Explore treatments",
    disciplines: ["Homeopathy", "Neuraltherapy", "Natural medicine", "Phytotherapy", "Clinical listening"],
    portraitCaption: "Dr. Giovanni Angilè — Physician and surgeon",
  },
  about: {
    eyebrow: "The doctor",
    title: "A clinical approach centred on the person's own story",
    body1: "A physician and surgeon with years of experience in integrative medicine, Dr. Angilè combines conventional diagnostics with natural disciplines, so that every care pathway starts from a complete understanding of the patient.",
    body2: "The first visit is devoted to listening: symptoms, pace of life, personal history. Only after proper diagnostic assessment is the most suitable pathway built together.",
    quote: "Time spent listening is not wasted time: it is therapy.",
    cta: "Read the curriculum",
  },
  treatments: {
    eyebrow: "Treatments",
    title: "The three disciplines of the practice",
    sub: "Three different languages of care, one method: diagnostic assessment before every therapeutic choice.",
    cta: "Learn more",
    topArticles: "The 4 most-read articles",
    reads: "reads",
    allArticles: "All articles in this section",
    items: [
      {
        name: "Homeopathy",
        tagline: "The principle of similars",
        description:
          "Homeopathic consultations with personalised remedies, complete assessment and scheduled follow-ups to evaluate patient responsiveness.",
      },
      {
        name: "Neuraltherapy",
        tagline: "Rebalancing the nerve signal",
        description:
          "Micro-injections of local anaesthetic in defined points — scars, reflex areas, ganglia — to rebalance the autonomic nervous system.",
      },
      {
        name: "Natural medicine",
        tagline: "Nutrition and lifestyle",
        description:
          "Conscious, natural nutrition can help restore the body's balance and accompany you towards a healthier lifestyle.",
      },
    ],
  },
  articles: {
    eyebrow: "Articles",
    title: "Writings and clinical reflections",
    sub: "Serious science communication: assessment first, in content too.",
    cta: "Read all articles",
    empty: "No articles published yet.",
    loading: "Loading…",
  },
  contacts: {
    eyebrow: "Contacts",
    title: "Book a visit",
    sub: "Write for information or to schedule an appointment at the practice.",
    form: {
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      message: "Message",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent. Thank you, you will be contacted shortly.",
      error: "Error sending. Please try again or call the practice directly.",
      bookingEyebrow: "Bookings",
      disabledBody: "For information and to book a visit, contact the practice directly.",
    },
    booking: {
      eyebrow: "Book online",
      title: "Book your visit",
      sub: "Choose an available day, then your preferred time: the practice will confirm your appointment.",
      pickDay: "1. Choose a day",
      pickTime: "2. Choose a time",
      details: "3. Your details",
      noSlots: "No times available for this day.",
      name: "Full name",
      phone: "Phone",
      email: "Email (optional)",
      notes: "Notes (optional)",
      confirm: "Confirm booking",
      submitting: "Sending…",
      success: "Request sent: the practice will confirm your appointment.",
      booked: "Oops, this time has just been booked. Please choose another.",
      error: "Error sending. Please try again or call the practice.",
      pickDayFirst: "Select a day to see available times",
    },
    info: {
      phone: "Phone",
      address: "Address",
      hours: "Office hours",
    },
    mapNote: "Custom map showing the practice address.",
    directions: "Get directions",
    openMap: "Directions also on OpenStreetMap",
  },
  curriculum: {
    eyebrow: "Curriculum",
    title: "Education, specialisations and clinical experience",
    formation: "Education",
    experiences: "Clinical experience",
    specializations: "Areas of specialisation",
    philosophy: "The clinical philosophy",
    philosophyBody:
      "To cure means to understand: every pathway starts from a complete history and an assessment shared with the patient. Natural disciplines do not replace conventional medicine: they integrate it, when there are the conditions to do so safely.",
  },
  footer: {
    tagline: "Medical practice of homeopathy, neuraltherapy and natural medicine.",
    nav: "Navigation",
    contacts: "Contacts",
    disclaimer:
      "The information on this website is purely informative and does not in any way replace the advice of a physician.",
    rights: "All rights reserved.",
  },
  admin: {
    login: "Reserved area",
    loginSub: "Sign in to manage articles and messages.",
    email: "Email",
    password: "Password",
    signIn: "Sign in",
    logout: "Sign out",
    tabArticles: "Articles",
    tabMessages: "Messages",
    newArticle: "New article",
    editArticle: "Edit article",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    title: "Title",
    titleEn: "Title (English)",
    category: "Category",
    excerpt: "Excerpt",
    excerptEn: "Excerpt (English)",
    content: "Content",
    contentEn: "Content (English)",
    cover: "Cover image (URL)",
    date: "Publication date",
    saved: "Article saved.",
    enSection: "English version (optional)",
    enSectionAdd: "Add English version (optional)",
    guideText:
      "Fields marked * are required: title, category, excerpt (short summary) and content. Image, section and the English version are optional — the English version stays hidden until needed.",
    deleted: "Article deleted.",
    confirmDelete: "Permanently delete this article?",
    noMessages: "No messages received.",
    loading: "Loading…",
    section: {
      tab: "Sections",
      new: "New section",
      edit: "Edit section",
      subtitle: "Subtitle",
      subtitleEn: "Subtitle (English)",
      body: "Content",
      bodyEn: "Content (English)",
      image: "Image (URL)",
      inMenu: "Show in navigation menu",
      order: "Display order",
      saved: "Section saved.",
      deleted: "Section deleted.",
      confirmDelete: "Permanently delete this section?",
      empty: "No sections created yet. Create one with the button on the top right.",
      notFound: "Section not found.",
    },
  },
  sectionPage: { notFound: "Section not found." },
  cancel: {
    title: "Cancel your booking",
    summary: "Your visit",
    time: "Time",
    name: "Patient",
    confirm: "Confirm cancellation",
    cancelling: "Cancelling…",
    done: "Booking cancelled",
    cancelled: "Your booking has been cancelled: the time slot is available again for other patients.",
    keep: "No, keep my booking",
    backHome: "Back to the site",
    invalid: "Invalid cancellation link or booking already cancelled.",
    error: "Error. Please try again or call the practice.",
  },
  marquee: ["Homeopathy", "Neuraltherapy", "Natural medicine", "Phytotherapy", "Clinical listening"],
  seo: {
    home: {
      title: "Homeopathy, Neuraltherapy and Natural Medicine — Dr. Angilè",
      desc: "Dr. Giovanni Angilè's medical practice in Selvazzano Dentro (PD), Italy: homeopathy, neuraltherapy and natural medicine. Tailored pathways, by appointment only.",
    },
    trattamenti: {
      title: "Treatments — Homeopathy, Neuraltherapy, Natural Medicine",
      desc: "The three disciplines of Dr. Angilè's practice: personalised homeopathic consultations, neuraltherapy for chronic pain, conscious nutrition and natural medicine.",
    },
    articoli: {
      title: "Articles on homeopathy and natural medicine — Dr. Angilè",
      desc: "Articles and clinical reflections by Dr. Angilè on homeopathy, neuraltherapy and natural medicine, with one principle: diagnostic assessment first.",
    },
    curriculum: {
      title: "Curriculum and clinical experience — Dr. Giovanni Angilè",
      desc: "Education, specialisations and clinical experience of Dr. Giovanni Angilè: classical homeopathy, neuraltherapy, phytotherapy and lifestyle medicine.",
    },
    contatti: {
      title: "Contacts and bookings — Dr. Angilè's practice (PD)",
      desc: "Book a visit or contact Dr. Angilè's practice in Selvazzano Dentro (PD), Italy: phone +39 349 234 4166, by appointment only.",
    },
    sezioni: {
      title: "Thematic sections — Dr. Angilè",
      desc: "The article sections of Dr. Angilè's site: homeopathy, neuraltherapy, natural medicine and the clinical method. In-depth reading with clinical rigour.",
    },
  },
  sezioniPage: {
    eyebrow: "Explore",
    title: "The sections",
    sub: "Each section gathers the articles on one theme: choose your reading path.",
    empty: "No sections published.",
    articles: "articles",
    article: "article",
  },
};

const dictionaries = { it, en };

export const curriculumData = {
  it: {
    profile:
      "Nato a Padova nel 1955, sposato, un figlio. Laureato in Medicina e Chirurgia nel 1987 presso l'Università di Padova con tesi: “Pletismografia ad impedenza nella diagnosi delle malattie circolatorie venose ed arteriose”. Abilitato all'Ordine dei Medici nella seconda sessione del 1987, iscritto all'Ordine dei Medici della provincia di Padova dal 1988.",
    formation: [
      { year: "1987", title: "Laurea in Medicina e Chirurgia", place: "Università di Padova — tesi in pletismografia ad impedenza" },
      { year: "1987–1989", title: "Corso triennale di Agopuntura", place: "C.I.A.M. — Centro Italiano d'Agopuntura Moderna, Padova" },
      { year: "1989–1991", title: "Corso triennale di Omeopatia", place: "Scuola Superiore di Omeopatia, Bologna — diploma riconosciuto anche da Homeopatia Universalis" },
      { year: "1992–1993", title: "Corso biennale di Kinesiologia Applicata", place: "Centro Internazionale della Medicina Integrata, Bologna" },
      { year: "1992–1993", title: "Corso biennale di Chiroterapia", place: "Centro Internazionale della Medicina Integrata, Bologna" },
      { year: "1998–2021", title: "Corsi e seminari di Neuralterapia", place: "SIMF (Verona, Milano) e Scuola Neuralia, Padova" },
      { year: "2003–2005", title: "Corsi di Ipnosi Medica", place: "SIMF, Sirmione" },
      { year: "2002–2005", title: "Formazione in medicina d'urgenza ed emergenza sanitaria", place: "BLS-D, PHTLS e PES — Roma e Bologna" },
    ],
    experiences: [
      { year: "Dal 1992", title: "Docente di Omeopatia", place: "Scuola SIM Pathos, Cividale del Friuli" },
      { year: "Dal 1997", title: "Collaboratore mensile della rivista “Biocalenda”", place: "Prevenzione e comportamenti salutistici — consulente scientifico e membro del consiglio direttivo de La Biolca, Battaglia Terme (PD)" },
      { year: "Dal 1999", title: "Didattica di Pronto Soccorso e Medicina del Lavoro", place: "Province di Padova, Vicenza e Verona" },
      { year: "Dal 2000", title: "Docente di Neuralterapia per medici", place: "SIMF, Milano" },
      { year: "Dal 2001", title: "Docente di medicina funzionale, diagnostica visiva e catene causali", place: "SIMF, Milano — formazione per farmacisti" },
      { year: "2002", title: "Socio fondatore dell'AINMF", place: "Associazione Italiana di Neuralterapia in Medicina Funzionale" },
      { year: "2002", title: "Pubblicazione di “Atlante illustrato di diagnostica visiva”", place: "Edizioni Named" },
      { year: "2001–2003", title: "Relatore in congressi di Neuralterapia", place: "SIMF Milano (“Cefalee e Neuralterapia”) e 1° Congresso Nazionale AINMF (“Allergie e Neuralterapia”)" },
      { year: "2004–2007", title: "Medico sociale", place: "Polisportiva Calcio Torreglia (PD)" },
      { year: "Dal 2005", title: "Trasmissioni televisive sulle Medicine Complementari", place: "Eden TV, Bassano TV, Free Channel (Sky)" },
      { year: "Dal 2009", title: "Trasmissioni radiofoniche in diretta e conferenze di medicina naturale", place: "Radio Gamma 5, Campodarsego (PD)" },
    ],
    specializations: [
      "Medicina Funzionale",
      "Omeopatia",
      "Omotossicologia",
      "Agopuntura e Riflessoterapie",
      "Chiroterapia",
      "Kinesiologia Applicata",
      "Neuralterapia",
      "Ipnosi Medica",
    ],
    seminarsTitle: "Seminari e formazione continua (1998–2010)",
    seminarsEyebrow: "Seminari di aggiornamento",
    seminars: [
      { title: "Osteopatia e terapia manuale globale, occlusione e postura", meta: "12-10-2002 · Verona" },
      { title: "La terapia del dolore in neuralterapia", meta: "16-11-2002 · Verona" },
      { title: "Omeomesoterapia nelle reumoartropatie", meta: "23-11-2002 · Venezia" },
      { title: "Benessere e P.N.E.I.: un approccio olistico alla qualità della vita", meta: "8-3-2003 · Venezia" },
      { title: "Una lettura innovativa della dinamica diagnostica delle patologie muscolo-scheletriche della spalla", meta: "29-3-2003 · Padova" },
      { title: "Aggiornamento diagnostico alle patologie del ginocchio", meta: "31-1-2004 · Padova" },
      { title: "Neuralterapia nelle patologie funzionali: approfondimento sulle patologie ginecologiche", meta: "22-5-2004 · Milano" },
      { title: "Oligoelementi ed alimentazione nella terapia d'integrazione delle malattie cronico-degenerative", meta: "22-23-10-2004" },
      { title: "Impostazione pratica della terapia isopatica", meta: "14-5-2005 · Padova" },
      { title: "PNEI e terapia biologica", meta: "11-2-2006 · Padova" },
      { title: "Fitoterapia, ma non solo. Corso di medicina naturale", meta: "7-5-2006 e 28-5-2006 · Padova" },
      { title: "Master clinico-pratico in immuno-isopatia Sanum", meta: "22-10, 5-11, 19-11 e 3-12-2006 · Padova" },
      { title: "Il drenaggio in Omeopatia", meta: "24-3-2007 · Padova" },
      { title: "Rimedi omeopatici e patologie osteoarticolari: l'approccio energetico razionale clinico-pratico", meta: "22-4-2007 · Padova" },
      { title: "Il depistage dell'arteriopatia obliterante periferica nel paziente a rischio cardiovascolare. Implicazioni diagnostiche e terapeutiche", meta: "22-9-2007 · Padova" },
      { title: "Rapporti tra medico e paziente", meta: "13-10-2007 · Padova" },
      { title: "Malattie croniche dell'apparato respiratorio: le malattie ostruttive croniche polmonari (BPCO ed Asma)", meta: "8-5-2008 · Abano Terme (PD)" },
      { title: "Master di 2° livello in immuno-isopatia", meta: "19-10-2008 · Padova" },
      { title: "Unicità dei fanghi di Abano, Montegrotto, Battaglia", meta: "27-6-2009 · Montegrotto Terme (PD)" },
      { title: "L'irregolarità dell'alvo: una malattia sociale, dal laboratorio alla clinica", meta: "19-6-2010 · Padova, prof. Renato De Magistris" },
      { title: "Master clinico-pratico in immuno-isopatia Sanum", meta: "10, 24-10 e 7-11-2010 · Padova" },
    ],
    emergencyTitle: "Corsi di emergenza sanitaria",
    emergency: [
      { title: "Corso teorico-pratico in medicina d'urgenza", meta: "Gennaio 2004 · Roma" },
      { title: "Rianimazione cardiopolmonare e defibrillazione precoce (BLS-D)", meta: "Dicembre 2002 · IRC Bologna — Giugno 2005 · SSMA Roma" },
      { title: "Pre Hospital Traumatic Life Support (PHTLS) e Perfezionamento nell'emergenza sanitaria (PES)", meta: "Luglio 2005 · SSMA Roma" },
    ],
  },
  en: {
    profile:
      "Born in Padua in 1955, married, one child. Graduated in Medicine and Surgery in 1987 at the University of Padua with a thesis on impedance plethysmography in the diagnosis of venous and arterial circulatory disorders. Licensed to practise in the second session of 1987; member of the Padua Medical Association since 1988.",
    formation: [
      { year: "1987", title: "Degree in Medicine and Surgery", place: "University of Padua — thesis on impedance plethysmography" },
      { year: "1987–1989", title: "Three-year course in Acupuncture", place: "C.I.A.M. — Centro Italiano d'Agopuntura Moderna, Padua" },
      { year: "1989–1991", title: "Three-year course in Homeopathy", place: "Scuola Superiore di Omeopatia, Bologna — diploma recognised by Homeopatia Universalis" },
      { year: "1992–1993", title: "Two-year course in Applied Kinesiology", place: "Centro Internazionale della Medicina Integrata, Bologna" },
      { year: "1992–1993", title: "Two-year course in Chirotherapy (manual therapy)", place: "Centro Internazionale della Medicina Integrata, Bologna" },
      { year: "1998–2021", title: "Courses and seminars in Neuraltherapy", place: "SIMF (Verona, Milan) and Scuola Neuralia, Padua" },
      { year: "2003–2005", title: "Courses in Medical Hypnosis", place: "SIMF, Sirmione" },
      { year: "2002–2005", title: "Training in emergency and urgent care medicine", place: "BLS-D, PHTLS and PES — Rome and Bologna" },
    ],
    experiences: [
      { year: "Since 1992", title: "Lecturer in Homeopathy", place: "SIM Pathos school, Cividale del Friuli" },
      { year: "Since 1997", title: "Monthly contributor to the magazine “Biocalenda”", place: "Health prevention — scientific consultant and board member of La Biolca, Battaglia Terme (PD)" },
      { year: "Since 1999", title: "Teaching Emergency Medicine and Occupational Medicine", place: "Provinces of Padua, Vicenza and Verona" },
      { year: "Since 2000", title: "Lecturer in Neuraltherapy for physicians", place: "SIMF, Milan" },
      { year: "Since 2001", title: "Lecturer in functional medicine and visual diagnostics", place: "SIMF, Milan — training for pharmacists" },
      { year: "2002", title: "Founding member of the AINMF", place: "Italian Association of Neuraltherapy in Functional Medicine" },
      { year: "2002", title: "Publication of “Atlante illustrato di diagnostica visiva”", place: "Edizioni Named" },
      { year: "2001–2003", title: "Speaker at Neuraltherapy congresses", place: "SIMF Milan (“Headaches and Neuraltherapy”) and 1st National AINMF Congress (“Allergies and Neuraltherapy”)" },
      { year: "2004–2007", title: "Team physician", place: "Polisportiva Calcio Torreglia (PD)" },
      { year: "Since 2005", title: "TV appearances on Complementary Medicine", place: "Eden TV, Bassano TV, Free Channel (Sky)" },
      { year: "Since 2009", title: "Live radio broadcasts and natural medicine lectures", place: "Radio Gamma 5, Campodarsego (PD)" },
    ],
    specializations: [
      "Functional Medicine",
      "Homeopathy",
      "Homotoxicology",
      "Acupuncture and reflex therapies",
      "Chirotherapy (manual therapy)",
      "Applied Kinesiology",
      "Neuraltherapy",
      "Medical Hypnosis",
    ],
    seminarsTitle: "Seminars and continuing education (1998–2010)",
    seminarsEyebrow: "Update seminars",
    seminars: [
      { title: "Osteopathy and global manual therapy, occlusion and posture", meta: "12-10-2002 · Verona" },
      { title: "Pain therapy in neuraltherapy", meta: "16-11-2002 · Verona" },
      { title: "Homomesotherapy in rheumatic arthropathies", meta: "23-11-2002 · Venice" },
      { title: "Wellness and PNEI: a holistic approach to quality of life", meta: "8-3-2003 · Venice" },
      { title: "An innovative reading of the diagnostic dynamics of musculoskeletal shoulder disorders", meta: "29-3-2003 · Padua" },
      { title: "Diagnostic update on knee pathologies", meta: "31-1-2004 · Padua" },
      { title: "Neuraltherapy in functional disorders: insights into gynaecological conditions", meta: "22-5-2004 · Milan" },
      { title: "Trace elements and nutrition in the integrative therapy of chronic degenerative diseases", meta: "22-23-10-2004" },
      { title: "Practical approach to isopathic therapy", meta: "14-5-2005 · Padua" },
      { title: "PNEI and biological therapy", meta: "11-2-2006 · Padua" },
      { title: "Phytotherapy, but not only. Natural medicine course", meta: "7-5-2006 and 28-5-2006 · Padua" },
      { title: "Clinical-practical Master in Sanum immuno-isopathy", meta: "22-10, 5-11, 19-11 and 3-12-2006 · Padua" },
      { title: "Drainage in Homeopathy", meta: "24-3-2007 · Padua" },
      { title: "Homeopathic remedies and osteoarticular conditions: the rational clinical-practical energetic approach", meta: "22-4-2007 · Padua" },
      { title: "Screening for peripheral artery disease in cardiovascular-risk patients. Diagnostic and therapeutic implications", meta: "22-9-2007 · Padua" },
      { title: "Doctor-patient relationships", meta: "13-10-2007 · Padua" },
      { title: "Chronic respiratory diseases: chronic obstructive pulmonary disease (COPD and Asthma)", meta: "8-5-2008 · Abano Terme (PD)" },
      { title: "Level 2 Master in immuno-isopathy", meta: "19-10-2008 · Padua" },
      { title: "The uniqueness of the Abano, Montegrotto and Battaglia muds", meta: "27-6-2009 · Montegrotto Terme (PD)" },
      { title: "Irregular bowel habit: a social disease, from laboratory to clinic", meta: "19-6-2010 · Padua, prof. Renato De Magistris" },
      { title: "Clinical-practical Master in Sanum immuno-isopathy", meta: "10, 24-10 and 7-11-2010 · Padua" },
    ],
    emergencyTitle: "Emergency care courses",
    emergency: [
      { title: "Theoretical-practical course in urgent care medicine", meta: "January 2004 · Rome" },
      { title: "Cardiopulmonary resuscitation and early defibrillation (BLS-D)", meta: "December 2002 · IRC Bologna — June 2005 · SSMA Rome" },
      { title: "Pre Hospital Traumatic Life Support (PHTLS) and Emergency Care Specialisation (PES)", meta: "July 2005 · SSMA Rome" },
    ],
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("angile-lang") || "it");
  const setLang = (l) => {
    localStorage.setItem("angile-lang", l);
    setLangState(l);
  };
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: dictionaries[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
